<template>
  <v-container fluid class="mx-1" v-if="languageData.labels">
      <v-row>
        <v-col cols="12">
          <v-stepper v-model="e1" class="transparent elevation-0">
            <v-card class="mb-5">
              <v-stepper-header class="autoheight" style="justify-content: flex-start !important">
                <div class="py-5 pl-5 mr-3">
                  <BackButton />
                </div>
                <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'max-width: 50px !important'"></v-divider>
                <v-stepper-step :complete="e1 > 1" @click="setStep(1)" step="1">{{ languageData.affiliate.main }}</v-stepper-step>
              </v-stepper-header>
            </v-card>
            <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null">
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card>
                    <v-row justify="center">
                      <v-col cols="12">
                          <p class="text-h5">{{ languageData.affiliate.main }}</p>
                          <v-row>
                            <v-col cols="12">
                                <v-text-field
                                  :label="languageData.affiliate.main"
                                  v-model="link"
                                  outlined
                                  height="55px"
                                  class="mb-4"
                                  disabled>
                                </v-text-field>
                            </v-col>
                          </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-card>
          </v-stepper>
        </v-col>
      </v-row>
  </v-container>
</template>
<script>
import BackButton from "../../../../components/Global/BackButton";
import { mapActions, mapState } from "vuex";
  export default {
    name: "AffiliateLinkForm",
    data() {
      return {
        e1: 1,
      }
    },
    components: {
      BackButton,
    },
    computed: {
        ...mapState("getAffiliateLink", {
            link: state => state.link
        }),
    },
    methods: {
        ...mapActions("getAffiliateLink", ["getAffiliateLinkRequest"]),
        setStep: function(step) {
            this.e1 = step;
        },
    },
    mounted() {
        this.getAffiliateLinkRequest();
    },
  }
</script>